import {
  FETCH_USERNAME_FAILED,
  FETCH_USERNAME_LOADING,
  FETCH_USERNAME_SUCCESS,
  CHECK_ANSWER_FAILED,
  CHECK_ANSWER_LOADING,
  CHECK_ANSWER_SUCCESS,
  HANDLE_PREV
} from '../actions/forgotPasswordActions'

const forgot = (state = { isFirstScreen: true, isLoading: false }, action) => {
  switch (action.type) {
    case FETCH_USERNAME_LOADING:
      return Object.assign({}, state, {
        isLoading: true
      })
    case FETCH_USERNAME_SUCCESS:
      return Object.assign({}, state, {
        isFirstScreen: false,
        question: action.response.question,
        userName: action.response.username,
        error: null,
        isLoading: false
      })
    case FETCH_USERNAME_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error
      })
    case CHECK_ANSWER_LOADING:
      return Object.assign({}, state, {
        isLoading: true
      })
    case CHECK_ANSWER_SUCCESS:
      return Object.assign({}, state, {
        isFirstScreen: false,
        isLoading: false,
        error: null
      })

    case CHECK_ANSWER_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error
      })
    case HANDLE_PREV:
      return Object.assign({}, state, {
        isFirstScreen: true,
        error: null
      })

    default:
      return state
  }
}

export default forgot



// WEBPACK FOOTER //
// ./src/redux/reducers/forgotPasswordReducer.js